import Vue from 'vue'
import Router from 'vue-router'
import LeaderBoard from './views/LeaderBoard.vue'
import Teams from './views/Teams.vue'
import PlayersGrid from './views/PlayersGrid.vue'
import TeamsGrid from './views/TeamsGrid.vue'
import Misc from './views/Misc.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'TeamsGrid',
      component: TeamsGrid
    },
    {
      path: '/leaderboard',
      name: 'LeaderBoard',
      component: LeaderBoard
    },
    {
      path: '/playersgrid',
      name: 'PlayersGrid',
      component: PlayersGrid
    },
    {
      path: '/teams',
      name: 'Teams',
      component: Teams
    },
    {
      path: '/misc',
      name: 'Misc',
      component: Misc
    }
  ]
})
